import { render, staticRenderFns } from "./DashboardEdit.vue?vue&type=template&id=0d8f7bff"
import script from "./DashboardEdit.vue?vue&type=script&lang=js"
export * from "./DashboardEdit.vue?vue&type=script&lang=js"
import style0 from "./DashboardEdit.vue?vue&type=style&index=0&id=0d8f7bff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports